import React from 'react';

import MuiAlert, { AlertProps as MuiAlertProps } from '@mui/material/Alert';

export type AlertProps = {} & MuiAlertProps;

export const Alert: React.FC<AlertProps> = (props) => (
  <MuiAlert {...props}>{props.children}</MuiAlert>
);
